import React from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";

export default function VipPage() {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div className="container introduce-page !mt-[70px]">
      <HeaderTop title={i18next.t("vip_title")} />
      <div className="flex flex-col items-center gap-4 p-4">
        <img
          src="https://api.demo92.apptestlive.com/assets/images/vip.webp"
          alt="Vip"
          className="w-[384px] max-w-[80%]"
        />
        <h2 className="text-2xl text-white text-center">
          {i18next.t("note31")}
        </h2>
        <span className="text-sm text-[#888] text-center">
          {i18next.t("note32")}
        </span>
        <div className="flex flex-col gap-6 w-full p-4 bg-[#1c1c1e] rounded">
          <div className="flex gap-2 items-center justify-center text-base text-[#888]">
            <div className="text-center">{i18next.t("current_level")}:</div>
            <div className="text-xl text-white text-center">
              {i18next.t("note33")}
            </div>
          </div>
          <Link
            className="py-[6px] px-4 bg-[#3d5afe] hover:bg-[#2a3db0] rounded text-center text-white text-sm font-medium"
            to="/cskh"
          >
            {i18next.t("note34")}
          </Link>
        </div>
      </div>
    </div>
  );
}
